import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654cae08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card shadow-sm mb-5" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title text-gray-800" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "fs-4 text-gray-700",
  style: {"white-space":"pre-line"}
}
const _hoisted_11 = {
  key: 1,
  class: "fs-4 text-gray-700"
}
const _hoisted_12 = { class: "row gx-5 mb-5 order-1" }
const _hoisted_13 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_14 = { class: "card card-xl-stretch" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "card-title text-gray-800" }
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = { class: "btn-disabled-countdown text-gray-500 border border-gray-500" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-gray-500 me-1" }, null, -1))
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "fs-4 text-gray-700" }
const _hoisted_23 = { class: "card-footer" }
const _hoisted_24 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "row d-inline-flex justify-content-around text-success" }
const _hoisted_27 = { class: "col px-0 mx-2" }
const _hoisted_28 = { class: "text-gray-700" }
const _hoisted_29 = {
  id: "days",
  class: "number fw-bold"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_31 = { class: "col px-0 mx-2" }
const _hoisted_32 = { class: "text-gray-700" }
const _hoisted_33 = {
  id: "hours",
  class: "number fw-bold"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_35 = { class: "col px-0 mx-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Min", -1))
const _hoisted_37 = {
  id: "minutes",
  class: "number fw-bold"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_39 = { class: "col px-0 mx-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Seg", -1))
const _hoisted_41 = {
  id: "seconds",
  class: "number fw-bold"
}
const _hoisted_42 = {
  key: 0,
  class: "row mb-5 order-1"
}
const _hoisted_43 = { class: "col-lg-12" }
const _hoisted_44 = { class: "card card-xl-stretch" }
const _hoisted_45 = { class: "card-header" }
const _hoisted_46 = { class: "card-title text-gray-800" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip text-success me-2" }, null, -1))
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "d-flex flex-column gap-2"
}
const _hoisted_53 = {
  class: "d-flex align-items-center",
  style: {"min-width":"0"}
}
const _hoisted_54 = { style: {"min-width":"0"} }
const _hoisted_55 = ["title"]
const _hoisted_56 = { class: "text-muted fs-8" }
const _hoisted_57 = {
  key: 0,
  class: "me-2"
}
const _hoisted_58 = { key: 1 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download" }, null, -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "row gap-2 gap-lg-0 order-2" }
const _hoisted_63 = { class: "card card-xl-stretch h-100" }
const _hoisted_64 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_65 = { class: "fs-6 text-gray-800 mt-3" }
const _hoisted_66 = { class: "card-toolbar" }
const _hoisted_67 = { class: "btn-disabled-countdown text-gray-500 border border-gray-500" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-gray-500 me-1" }, null, -1))
const _hoisted_69 = { class: "fs-7" }
const _hoisted_70 = { class: "card-body" }
const _hoisted_71 = { class: "card-footer" }
const _hoisted_72 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_73 = { class: "text-center" }
const _hoisted_74 = { class: "row d-inline-flex justify-content-around text-success" }
const _hoisted_75 = { class: "col px-0 mx-1" }
const _hoisted_76 = { class: "text-gray-700" }
const _hoisted_77 = {
  id: "days",
  class: "number-two fw-bold"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number-two"
  }, ":")
], -1))
const _hoisted_79 = { class: "col px-0 mx-1" }
const _hoisted_80 = { class: "text-gray-700" }
const _hoisted_81 = {
  id: "hours",
  class: "number-two fw-bold"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number-two"
  }, ":")
], -1))
const _hoisted_83 = { class: "col px-0 mx-1" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Min", -1))
const _hoisted_85 = {
  id: "minutes",
  class: "number-two fw-bold"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number-two"
  }, ":")
], -1))
const _hoisted_87 = { class: "col px-0 mx-1" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Seg", -1))
const _hoisted_89 = {
  id: "seconds",
  class: "number-two fw-bold"
}
const _hoisted_90 = {
  key: 1,
  class: "row d-flex justify-content-center"
}
const _hoisted_91 = {
  class: "card shadow-sm w-full",
  style: {"height":"613px"}
}
const _hoisted_92 = { class: "card-body" }
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = { class: "container text-center mt-5" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_96 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }
const _hoisted_97 = { class: "row mt-5 mx-1" }
const _hoisted_98 = { class: "card" }
const _hoisted_99 = { class: "card-body" }
const _hoisted_100 = { class: "d-flex flex-column" }
const _hoisted_101 = { class: "justify-content-center d-flex align-items-center" }
const _hoisted_102 = { class: "d-flex align-items-center me-5" }
const _hoisted_103 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_104 = ["checked"]
const _hoisted_105 = { class: "form-check-label text-gray-800" }
const _hoisted_106 = { class: "" }
const _hoisted_107 = {
  key: 1,
  style: {"padding":"8px 16px"},
  class: "bg-secondary ki-text-bold fs-7 d-flex text-gray-600 justify-content-center align-items-center rounded"
}
const _hoisted_108 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_109 = { class: "container text-center mt-5" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_111 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import {computed, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import moment from "moment/moment";
import CardMachine from "@/components/certification/CardMachine.vue";
import ApiService from "@/core/services/ApiService";
import { useCertificationSteps } from "@/core/composables/useCertificationSteps";
import { useCertificationExecution } from "@/core/composables/useCertificationExecution";
import { formatBrasilia } from "@/core/helpers/dates";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const store = useStore();
const router = useRouter();

// Composable para gerenciar steps da certificação
const {
  loading: configLoading,
  strategyType,
  currentStep,
  expectedStepForComponent,
  isOnCorrectStep,
  getNextStepRoute,
  loadCertificationData,
  statusData,
  configData,
  getStepByType,
} = useCertificationSteps(props.id, 'certification_to_do');

const executionStep = computed(() => getStepByType('execution'));
const executionTitle = computed(() => executionStep.value?.title?.trim() || null);
const executionMessage = computed(() => executionStep.value?.message?.trim() || null);

// Composable para lógica de execução compartilhada
const {
  machines,
  timeRemaining,
  deadline,
  created_at,
  showMachine,
  initializeMachinesAndCountdown,
  fetchDeadline,
} = useCertificationExecution(props.id);

// Início do prazo deste step vem direto do backend (current_step_started_at), com fallback no created_at
const stepStartedAt = computed(() => statusData.value?.current_step_started_at ?? statusData.value?.created_at ?? null);

const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const terms = ref(false);
const isChecked = ref(false);
const showCountdown = ref(false);
const loading = ref(false);

const executionAttachments = ref<Array<{
  attachment_id: number;
  name: string;
  mime_type: string | null;
  file_size: number | null;
  download_url: string;
  expires_at: string | null;
}>>([]);
const loadingAttachments = ref(false);

const loadExecutionAttachments = async () => {
  loadingAttachments.value = true;
  try {
    const response = await ApiService.get(`/certification/${props.id}/attachments/execution`);
    const list = response.data.attachments ?? [];
    executionAttachments.value = Array.isArray(list) ? list : [];
  } catch (e) {
    console.error("Erro ao carregar anexos da execução:", e);
    executionAttachments.value = [];
  } finally {
    loadingAttachments.value = false;
  }
};

const downloadAttachment = (attachment) => {
  if (attachment?.download_url) {
    window.open(attachment.download_url, '_blank');
  }
};

const attachmentIcon = (mime: string | null) => {
  if (!mime) return 'bi-file-earmark';
  if (mime === 'application/pdf') return 'bi-file-pdf';
  if (mime.startsWith('image/')) return 'bi-file-image';
  if (mime.startsWith('video/')) return 'bi-file-play';
  if (mime.includes('zip') || mime.includes('compressed') || mime.includes('tar') || mime.includes('7z')) return 'bi-file-zip';
  if (mime.includes('text') || mime.includes('json') || mime.includes('xml') || mime.includes('javascript')) return 'bi-file-code';
  return 'bi-file-earmark';
};

const formatFileSize = (bytes: number | null) => {
  if (!bytes && bytes !== 0) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(size >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

// Computed para combinar loading states
const isLoading = computed(() => loading.value || configLoading.value);

const getDeadline = async () => {
  try {
    showCountdown.value = false;
    const statusData = await fetchDeadline();
    
    if (statusData) {
      // Verifica se está no step esperado para este componente
      if (statusData.current_step === expectedStepForComponent.value) {
        // Sempre inicializa automaticamente (para CASP step 3 e DEFAULT step 2)
        await initializeMachinesAndCountdown(redirectToNextStep);
      } else {
        // Usuário não está no step correto, deixa o guard redirecionar
        console.log('Usuário não está no step correto para esta view');
      }
    }
  } catch (e) {
    console.error("Erro ao buscar o deadline:", e);
    if (e.response?.data?.message === "certificado ainda não iniciado") {
      await router.push({name: 'certifications'});
    }
  } finally {
    showCountdown.value = true;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    // Carrega configuração e status da certificação
    await loadCertificationData();
    
    // Depois carrega os dados específicos desta view
    await getDeadline();
    await loadExecutionAttachments();
  } catch (e) {
    console.error('Erro ao carregar dados:', e);
    await router.push({name: 'certifications'});
  } finally {
    loading.value = false;
  }
});

const checkedTerms = () => {
  isChecked.value = !isChecked.value;
  terms.value = isChecked.value;
};

const formatDate = (date: string) => formatBrasilia(date);

const redirectToNextStep = async () => {
  loading.value = true;
  try {
    // Sempre usa advance-step
    await ApiService.post(`/certification/${props.id}/advance-step`);
    
    // Redireciona para o próximo step
    const nextRoute = getNextStepRoute();
    if (nextRoute) {
      await router.push({name: nextRoute, params: {id: props.id}});
    } else {
      await router.push({name: 'certifications'});
    }
  } catch (e) {
    console.error("Erro ao avançar para próximo step:", e);
  } finally {
    loading.value = false;
  }
};

const threeMachines = computed(() => {
  return machines.value.length === 3 || machines.value.length === 0;
});

const lengthMachines = computed(() => {
  if(machines.value.length === 2) {
    return {
      text: 'fs-7',
      class: "col-lg-4"
    }
  } else if(machines.value.length === 1) {
    return {
      text: 'fs-4',
      class: "col-lg-8"
    }
  } else {
    return {
      text: '',
      class: ""
    }
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (!_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(executionTitle) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.to_do.title`)), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(executionMessage))
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(executionMessage)), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.description`)), 1))
            ])
          ]),
          (showCountdown.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_12, [
                  (_unref(threeMachines))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline`)), 1),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.challenge_started`)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("p", _hoisted_22, [
                              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_1`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(!_unref(stepStartedAt) ? '00/00/0000 00:00' : formatDate(_unref(stepStartedAt))) + "h", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_2`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(deadline) === undefined ? '00/00/0000 00:00' : formatDate(_unref(deadline))) + "h", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_3`)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.day`)), 1),
                                    _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(timeRemaining).days.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_30,
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hours`)), 1),
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(timeRemaining).hours.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, [
                                    _hoisted_36,
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(timeRemaining).minutes.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_38,
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(timeRemaining).seconds.toString().padStart(2, '0')), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (executionAttachments.value.length > 0 || loadingAttachments.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("h3", _hoisted_46, [
                              _hoisted_47,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.execution_attachments`)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            (loadingAttachments.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                              : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(executionAttachments.value, (att) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: att.attachment_id,
                                      class: "d-flex align-items-center justify-content-between p-3 bg-light bg-opacity-10 rounded border border-gray-700"
                                    }, [
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(['bi', attachmentIcon(att.mime_type), 'text-success me-2 fs-3'])
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("div", {
                                            class: "text-gray-800 fw-bold text-truncate",
                                            title: att.name
                                          }, _toDisplayString(att.name), 9, _hoisted_55),
                                          _createElementVNode("div", _hoisted_56, [
                                            (att.mime_type)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(att.mime_type), 1))
                                              : _createCommentVNode("", true),
                                            (att.file_size)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(formatFileSize(att.file_size)), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm btn-light-success ms-3",
                                        onClick: ($event: any) => (downloadAttachment(att))
                                      }, _hoisted_61, 8, _hoisted_59)
                                    ]))
                                  }), 128))
                                ]))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_62, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machines), (machine) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: machine.id,
                      class: "col-lg-4"
                    }, [
                      _createVNode(CardMachine, {
                        machine: machine,
                        type: 'certification',
                        "certification-id": props.id
                      }, null, 8, ["machine", "certification-id"])
                    ]))
                  }), 128)),
                  (!_unref(threeMachines))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_unref(lengthMachines).class)
                      }, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("h4", _hoisted_65, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline`)), 1),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.challenge_started`)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["text-gray-700 mt-1", _unref(lengthMachines).text])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_1`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(!_unref(stepStartedAt) ? '00/00/0000 00:00' : formatDate(_unref(stepStartedAt))) + "h", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_2`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(deadline) === undefined ? '00/00/0000 00:00' : formatDate(_unref(deadline))) + "h", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_3`)), 1)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.day`)), 1),
                                    _createElementVNode("div", _hoisted_77, _toDisplayString(_unref(timeRemaining).days.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_78,
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("p", _hoisted_80, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hours`)), 1),
                                    _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(timeRemaining).hours.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_82,
                                  _createElementVNode("div", _hoisted_83, [
                                    _hoisted_84,
                                    _createElementVNode("div", _hoisted_85, _toDisplayString(_unref(timeRemaining).minutes.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_86,
                                  _createElementVNode("div", _hoisted_87, [
                                    _hoisted_88,
                                    _createElementVNode("div", _hoisted_89, _toDisplayString(_unref(timeRemaining).seconds.toString().padStart(2, '0')), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createElementVNode("span", _hoisted_96, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.analyzing_machines_and_calculating_time`)) + "...", 1)
                      ])
                    ])
                  ])
                ])
              ])),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("label", _hoisted_103, [
                        _createElementVNode("input", {
                          onClick: checkedTerms,
                          class: "form-check-input w-15px h-15px",
                          type: "checkbox",
                          checked: isChecked.value
                        }, null, 8, _hoisted_104),
                        _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.finish_challenge_and_make_the_report`)) + "! ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      (terms.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: redirectToNextStep,
                            class: "btn btn-sm btn-light-success"
                          }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.make_report`)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.make_report`)), 1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("span", _hoisted_111, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.analyzing_the_requirements`)) + "...", 1)
          ])
        ]))
  ], 64))
}
}

})